
export const mergeJustificaciones = (dataFromDb, cantidad) => {
    const nuevos = Array.from({ length: cantidad }, (_, i) => ({
        idComboVisitaValorMotivoJustificacion: null,
        fechaVisita: '',
        observacion: '',
        idDb: null
    }));

    const merged = [...dataFromDb, ...nuevos].map((item, index) => ({
        ...item,
        id: index + 1
    }));

    return merged;
};